import React, { useState, useEffect, FunctionComponent, useContext } from 'react';
import { navigate, RouteComponentProps, globalHistory } from '@reach/router';
import { signin } from '@v10-codeparva/v10-tfw-revamp-package-api';
import { LoginForm } from '../login/LogInForm';
import { FacilityContext, LocationContext, LayoutContext } from '../../context';
import { LoginFormTransformer } from 'transformers/loginFormTransformer';
import { useCookie } from '../../../utils/auth';
import { localisable } from '../../../generic/localisable';
import { navigateTo } from 'utils/routeHelpers';

export const LoginPage: FunctionComponent<RouteComponentProps> = ({ location }: { location: any }) => {
    const facilityContext: any = useContext(FacilityContext);
    const locationContext: any = useContext(LocationContext);
    const layoutContext: any = useContext(LayoutContext);
    const transformerData = LoginFormTransformer(locationContext[0])
    const [_, setCToken] = useCookie('cToken');
    const path = location?.state?.path || 'payment';
    const [loginError, setLoginError] = useState('');
    const [cpLoginError, setCpLoginError] = useState('');


    const SignInHandler = (requestBody: any, action: string, setIsLoading: any) => {
        signin(requestBody).then((signInApiResponse) => {
            const {
                strTenantToken, blnSuccess
            } = signInApiResponse;
            if (blnSuccess) {
                if (action === 'login') {
                    setCToken(strTenantToken)
                    navigateTo(path, 'pay-rent', 'navigate', null);
                } else if (action === 'resetPassword') {
                    const state = {
                        token: strTenantToken,
                    };
                    navigate('reset-password', {
                        replace: true,
                        state: {
                            ...state
                        }
                    })
                }
            }
            else {
                if (action === 'login') {
                    setLoginError(localisable.userNameAndCredentialsError);
                } else if (action === 'resetPassword') {
                    setCpLoginError(localisable.userNameAndCredentialsError);
                }
            }
            if (setIsLoading) {
                setIsLoading(false);
            }
        }).catch((error) => {
            if (error.response) {
                console.log(error.response.data); // => the response payload 
            }
            setLoginError(localisable.userNameAndCredentialsError);
        })
    };

    const onSubmitFormHandler = async (fieldData: any) => {
        const requestBody = {
            strUserName: fieldData.userName,
            strPassword: fieldData.password,
            cid: process.env.CID || '',
        }
        setLoginError('');
        SignInHandler(requestBody, 'login', null);
    };

    const onSubmitCpLoginForm = async (
        fieldData: any,
        setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
    ) => {
        const requestBody = {
            strUserName: fieldData.userName,
            strPassword: fieldData.password,
            cid: process.env.CID || '',
        }
        SignInHandler(requestBody, 'resetPassword', setIsLoading);
    };


    return (
        <LoginForm
            facilityMailingAddress={transformerData.facilityMailingAddress}
            facilityAddress={transformerData.facilityAddress}
            facilityMail={transformerData.facilityMail}
            facilityPhone={transformerData.facilityPhone}
            addressMapUrl={transformerData.addressMapUrl}
            mailingAddressMapUrl={transformerData.mailingAddressMapUrl}
            cpLoginError={cpLoginError}
            onSubmitForm={onSubmitFormHandler}
            loginError={loginError}
            onSubmitCpLoginForm={onSubmitCpLoginForm}
        />
    )
};